import BidIncrementButton from '@components/BidIncrementButton'
import React from 'react'
import BidBidderIcon from '../../../../elements/BidBidderIcon/BidBidderIcon'
import { FaPeopleGroup } from 'react-icons/fa6'
import { useItemPage } from '@components/ItemPage/Layout/ItemPageContext'
import BidHistory from '@components/Cards/BidItem/BidHistory'

const CurrentBid = ({ loadingBid }: any) => {
  const {
    itemState: { currentBid, bidsEnabled, itemBidIncrementEnabled, bidHistory },
    itemHandler: { closeBidHistory, openBidHistory },
    modal: {
      handlers: { setIncrementModalVisible },
    },
  } = useItemPage()
  return (
    <>
      {(currentBid === 0 || currentBid) && bidsEnabled && (
        <div className="flex">
          <div className="flex gap-1 xs:gap-2 items-end text-bidfta-blue-light">
            <button
              onClick={openBidHistory}
              className={`text-10 xs:text-12 font-semibold  transition duration-300 ease-in-out flex tracking-tight gap-0.5 ${
                loadingBid ? ' opacity-25' : 'opacity-100'
              }`}
            >
              <FaPeopleGroup size={16} className={'text-bidfta-blue-light'} />
              <div className="relative">
                <BidHistory
                  visible={bidHistory.visible}
                  bidHistory={bidHistory.values}
                  closeBidHistory={closeBidHistory}
                  options={{
                    isListView: false,
                    isBidsPage: false,
                    isWatchlistPage: true,
                    cardIndex: 0,
                    twss: 'text-black',
                  }}
                />
              </div>
              CURRENT BID
            </button>
            <div className="text-xl font-semibold">
              ${currentBid.toFixed(2)}
            </div>
          </div>

          {itemBidIncrementEnabled && (
            <div className="ml-2 -mb-2">
              <BidIncrementButton setModalVisible={setIncrementModalVisible} />
            </div>
          )}
        </div>
      )}
    </>
  )
}

export default CurrentBid
